export const HomeReducer = (state, action) => {
    switch (action.type) {
        case "SET_LOADING":
            return {
                ...state,
                isLoading: true,
            };
        case "SET_DATA":
            // Ensure action.payload is an array before using .filter()
            //const hotCategoriesData = Array.isArray(action.payload) ? action.payload.filter((curElem) => curElem.isAdmin === true) : [];
            return {
                ...state,
                isLoading: false,
                //HomeData: Array.isArray(action.payload) ? action.payload : [], // Fallback to empty array if payload isn't an array
                HomeData: action.payload,
                //HotCategories: hotCategoriesData,
            };
        case "ERROR_RESPONSE":
            return {
                ...state,
                isLoading: false,
                isError: true,
            };
        case "ERROR_REQUEST":
            return {
                ...state,
                isLoading: false,
                isError: true,
            };
        case "ERROR_MESSAGE":
            return {
                ...state,
                isLoading: false,
                isError: true,
            };
        default:
            return state;
    }
};
  
export const AboutReducer = (state, action) => {
    switch (action.type) {
        case "SET_LOADING":
            return {
                ...state,
                isLoading: true,
            };
        case "SET_DATA":
            // Ensure action.payload is an array before using .filter()
            //const hotCategoriesData = Array.isArray(action.payload) ? action.payload.filter((curElem) => curElem.isAdmin === true) : [];
 
            return {
                ...state,
                isLoading: false,
                //HomeData: Array.isArray(action.payload) ? action.payload : [], // Fallback to empty array if payload isn't an array
                AboutData: action.payload,
                //HotCategories: hotCategoriesData,
            };
        case "ERROR_RESPONSE":
            return {
                ...state,
                isLoading: false,
                isError: true,
            };
        case "ERROR_REQUEST":
            return {
                ...state,
                isLoading: false,
                isError: true,
            };
        case "ERROR_MESSAGE":
            return {
                ...state,
                isLoading: false,
                isError: true,
            };
        default:
            return state;
    }
};
 
export const ContactReducer = (state, action) => {
    switch (action.type) {
        case "":
            return {
                ...state, 
            };
        case "SET_DATA":
            // Ensure action.payload is an array before using .filter()
            //const hotCategoriesData = Array.isArray(action.payload) ? action.payload.filter((curElem) => curElem.isAdmin === true) : [];
 
            return {
                ...state,
                isLoading: false,
                //ContactData: Array.isArray(action.payload) ? action.payload : [], // Fallback to empty array if payload isn't an array
                ContactData: action.payload,
                //HotCategories: hotCategoriesData,
            };
        case "ERROR_RESPONSE":
            return {
                ...state,
                isLoading: false,
                isError: true,
            };
        case "ERROR_REQUEST":
            return {
                ...state,
                isLoading: false,
                isError: true,
            };
        case "ERROR_MESSAGE":
            return {
                ...state,
                isLoading: false,
                isError: true,
            };
        default:
            return state;
    }
}; 
 
export const CustomizedReducer = (state, action) => {
    switch (action.type) {
        case "SET_LOADING":
            return {
                ...state,
                isLoading: true,
            };
        case "SET_DATA":
            // Ensure action.payload is an array before using .filter()
            //const hotCategoriesData = Array.isArray(action.payload) ? action.payload.filter((curElem) => curElem.isAdmin === true) : [];
 
            return {
                ...state,
                isLoading: false,
                //HomeData: Array.isArray(action.payload) ? action.payload : [], // Fallback to empty array if payload isn't an array
                CustomizedData: action.payload,
                //HotCategories: hotCategoriesData,
            };
        case "ERROR_RESPONSE":
            return {
                ...state,
                isLoading: false,
                isError: true,
            };
        case "ERROR_REQUEST":
            return {
                ...state,
                isLoading: false,
                isError: true,
            };
        case "ERROR_MESSAGE":
            return {
                ...state,
                isLoading: false,
                isError: true,
            };
        default:
            return state;
    }
};

export const WhyChooseUsReducer = (state, action) => {
    switch (action.type) {
        case "SET_LOADING":
            return {
                ...state,
                isLoading: true,
            };
        case "SET_DATA":
            // Ensure action.payload is an array before using .filter()
            //const hotCategoriesData = Array.isArray(action.payload) ? action.payload.filter((curElem) => curElem.isAdmin === true) : [];
 
            return {
                ...state,
                isLoading: false,
                //HomeData: Array.isArray(action.payload) ? action.payload : [], // Fallback to empty array if payload isn't an array
                whychooseUsData: action.payload,
                //HotCategories: hotCategoriesData,
            };
        case "ERROR_RESPONSE":
            return {
                ...state,
                isLoading: false,
                isError: true,
            };
        case "ERROR_REQUEST":
            return {
                ...state,
                isLoading: false,
                isError: true,
            };
        case "ERROR_MESSAGE":
            return {
                ...state,
                isLoading: false,
                isError: true,
            };
        default:
            return state;
    }
};

export const PrivacyPolicyReducer = (state, action) => {
    switch (action.type) {
        case "SET_LOADING":
            return {
                ...state,
                isLoading: true,
            };
        case "SET_DATA":
            // Ensure action.payload is an array before using .filter()
            //const hotCategoriesData = Array.isArray(action.payload) ? action.payload.filter((curElem) => curElem.isAdmin === true) : [];
 
            return {
                ...state,
                isLoading: false,
                //HomeData: Array.isArray(action.payload) ? action.payload : [], // Fallback to empty array if payload isn't an array
                PrivacyPolicyData: action.payload,
                //HotCategories: hotCategoriesData,
            };
        case "ERROR_RESPONSE":
            return {
                ...state,
                isLoading: false,
                isError: true,
            };
        case "ERROR_REQUEST":
            return {
                ...state,
                isLoading: false,
                isError: true,
            };
        case "ERROR_MESSAGE":
            return {
                ...state,
                isLoading: false,
                isError: true,
            };
        default:
            return state;
    }
};

export const TermAndConditionReducer = (state, action) => {
    switch (action.type) {
        case "SET_LOADING":
            return {
                ...state,
                isLoading: true,
            };
        case "SET_DATA":
            // Ensure action.payload is an array before using .filter()
            //const hotCategoriesData = Array.isArray(action.payload) ? action.payload.filter((curElem) => curElem.isAdmin === true) : [];
 
            return {
                ...state,
                isLoading: false,
                //HomeData: Array.isArray(action.payload) ? action.payload : [], // Fallback to empty array if payload isn't an array
                TermAndConditionData: action.payload,
                //HotCategories: hotCategoriesData,
            };
        case "ERROR_RESPONSE":
            return {
                ...state,
                isLoading: false,
                isError: true,
            };
        case "ERROR_REQUEST":
            return {
                ...state,
                isLoading: false,
                isError: true,
            };
        case "ERROR_MESSAGE":
            return {
                ...state,
                isLoading: false,
                isError: true,
            };
        default:
            return state;
    }
};

export const FaqsReducer = (state, action) => {
    switch (action.type) {
        case "SET_LOADING":
            return {
                ...state,
                isLoading: true,
            };
        case "SET_DATA":
            // Ensure action.payload is an array before using .filter()
            //const hotCategoriesData = Array.isArray(action.payload) ? action.payload.filter((curElem) => curElem.isAdmin === true) : [];
 
            return {
                ...state,
                isLoading: false,
                //HomeData: Array.isArray(action.payload) ? action.payload : [], // Fallback to empty array if payload isn't an array
                FaqsData: action.payload,
                //HotCategories: hotCategoriesData,
            };
        case "ERROR_RESPONSE":
            return {
                ...state,
                isLoading: false,
                isError: true,
            };
        case "ERROR_REQUEST":
            return {
                ...state,
                isLoading: false,
                isError: true,
            };
        case "ERROR_MESSAGE":
            return {
                ...state,
                isLoading: false,
                isError: true,
            };
        default:
            return state;
    }
};
export const OurCollectionsReducer = (state, action) => {
    switch (action.type) {
        case "SET_LOADING":
            return {
                ...state,
                isLoading: true,
            };
        case "SET_DATA": 
            return {
                ...state,
                isLoading: false,
                //HomeData: Array.isArray(action.payload) ? action.payload : [], // Fallback to empty array if payload isn't an array
                OurCollectionsData: action.payload,
                //FilterSubOurCollectionsData: FilterCollectionsData,
            };
        case "ERROR_RESPONSE":
            return {
                ...state,
                isLoading: false,
                isError: true,
            };
        case "ERROR_REQUEST":
            return {
                ...state,
                isLoading: false,
                isError: true,
            };
        case "ERROR_MESSAGE":
            return {
                ...state,
                isLoading: false,
                isError: true,
            };
            case "SET_SINGLE_LOADING":
            return {
                ...state,
                isSingleLoading: true,
            };
            case "SET_SINGLE_DATA":
            return {
                ...state,
                isSingleLoading:false,
                SingleCollectionData: action.payload,
            };
            case "ERROR_SINGLE_RESPONSE":
                return {
                    ...state,
                    isSingleLoading: false,
                    isError: true,
                };

                case "SET_CATEGORIES_LOADING":
                    return {
                        ...state,
                        isCollectionCategoriesLoading: true,
                    };
                    case "SET_CATEGORIES_DATA":
                    return {
                        ...state,
                        isCollectionCategoriesLoading:false,
                        CollectionCategoriesData: action.payload,
                    };
                    case "ERROR_CATEGORIES_RESPONSE":
                        return {
                            ...state,
                            isCollectionCategoriesLoading: false,
                            isError: true,
                        };

        default:
            return state;
    }
};